import { render, staticRenderFns } from "./add-achievement.vue?vue&type=template&id=1ec6fca9&scoped=true&"
import script from "./add-achievement.vue?vue&type=script&lang=js&"
export * from "./add-achievement.vue?vue&type=script&lang=js&"
import style0 from "./add-achievement.vue?vue&type=style&index=0&id=1ec6fca9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec6fca9",
  null
  
)

export default component.exports